export default __webpack_public_path__ + "static/media/031-cctv.bedb50f0.svg";